import React from 'react';
import type { PreviewRecipient } from '../segments-tab/segment-definitions-api';
import styles from './EditSegment.module.css';

interface RecipientCardProps {
  recipient: PreviewRecipient;
}

function formatName(recipient: PreviewRecipient): string {
  const { firstName, lastName } = recipient;
  if (firstName || lastName) {
    return `${firstName || ''} ${lastName || ''}`.trim();
  }
  return 'Unknown';
}

export const RecipientCard: React.FC<RecipientCardProps> = ({ recipient }) => {
  return (
    <li className={styles.recipientCard}>
      <p>{formatName(recipient)}</p>
      {recipient.email && <p>{recipient.email}</p>}
      {recipient.phone && <p>{recipient.phone}</p>}
    </li>
  );
};
